import apiUtils from '../../utils/apiUtils';

const paypalService = {
  getClientToken: async function (config) {
    const { apiAccessToken, baseURL, brand, environment } = config;

    const isProd = environment === 'prod';

    const path = '/payments/railcards/paypal/token';
    const url = isProd ? `https://api.${baseURL}${path}` : `https://api-${brand}.${baseURL}${path}`;

    const { token } = await apiUtils.post({
      apiAccessToken,
      url,
    });
    return token;
  },

  checkout: async function ({ amount, railcardId, deviceData, nonce, token, config }) {
    const { apiAccessToken, baseURL, brand, environment } = config;

    const isProd = environment === 'prod';

    const path = '/payments/railcards/paypal/checkout';
    const url = isProd ? `https://api.${baseURL}${path}` : `https://api-${brand}.${baseURL}${path}`;

    const data = {
      railcardId,
      payment: {
        amount,
        nonce,
        deviceData,
      },
    };

    const result = await apiUtils.post({
      apiAccessToken,
      url,
      data,
      token,
    });

    return result;
  },
};

export default paypalService;
